import InputForm from "../inputs/InputForm";
import FormList from "./FormList";

const FormContent = ({
  elemento,
  campos = [],
  opciones,
  data,
  setData,
  listado,
  isDouble = false,
  campoNoEditable = null,
  /* Lo que la lista de artículos necesita además del listado: el puente con
     el tablero de herramientas de `FormMovimientoStock` (ver `FormList`). Los
     demás formularios no lo pasan y la lista queda como siempre. */
  listaProps = {},
}) => {
  const modoEdicion = !!elemento;

  const handleChange = (key, value) => {
    setData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const bloquePrincipal = campos.filter((cp) => cp.type === "principal");
  const bloqueSecondary = campos.filter((cp) => cp.type === "secondary");

  /* ── SECCIONES CON NOMBRE PROPIO, CUANDO EL FORMULARIO LAS PIDE ─────────
   *
   * Los títulos eran dos y fijos: «Información» y «Otros datos». Alcanzan
   * para un formulario de cinco campos; en el de una persona, que son
   * dieciocho, «Otros datos» junta el legajo con la obra social y hay que
   * leer los dieciocho para encontrar uno.
   *
   * Un campo puede traer `grupo` con el título bajo el que va. Si NINGUNO lo
   * trae —los otros diez formularios— esto no se activa y se dibuja como
   * siempre: es aditivo, no un cambio de comportamiento.
   *
   * El ORDEN de las secciones es el orden en que aparecen los campos, no
   * alfabético: el que arma la lista decide qué se pregunta primero, que es
   * la mitad de que un formulario se sienta corto.
   */
  const conGrupo = campos.filter(
    (cp) => cp.grupo && (cp.type === "principal" || cp.type === "secondary"),
  );
  const grupos = [];
  for (const cp of conGrupo) {
    let g = grupos.find((x) => x.titulo === cp.grupo);
    if (!g) grupos.push((g = { titulo: cp.grupo, campos: [] }));
    g.campos.push(cp);
  }
  const porGrupos = grupos.length > 0;
  const bloqueComplete = campos.filter((cp) => cp.type === "group");
  const bloqueChecks = campos.filter((cp) => cp.type === "checks");

  const dibujar = (campo) => (
    <InputForm
      key={campo.key}
      campo={campo}
      value={data[campo.key]}
      onChange={handleChange}
      opciones={opciones}
      modoEdicion={modoEdicion}
      campoNoEditable={campoNoEditable}
    />
  );

  return (
    <>
      {porGrupos &&
        grupos.map((g) => (
          <div key={g.titulo} className={`${isDouble ? "doble-form-left" : ""}`}>
            <label>
              <strong className="form-info-title">{g.titulo}</strong>
              {/* La aclaración de la sección, cuando la tiene. Va acá y no en
                  cada campo: seis campos con el mismo cartel al lado es ruido,
                  y lo que se está diciendo es de la sección entera. */}
              {g.campos[0]?.grupoNota && (
                <span className="form-info-nota">{g.campos[0].grupoNota}</span>
              )}
            </label>
            <div className="form-info-box">{g.campos.map(dibujar)}</div>
          </div>
        ))}
      {!porGrupos && bloquePrincipal.length > 0 && (
        <div className={`${isDouble ? "doble-form-left" : ""}`}>
          <label>
            <strong className="form-info-title">Información</strong>
          </label>
          <div className="form-info-box">
            {bloquePrincipal.map((campo) => (
              <InputForm
                key={campo.key}
                campo={campo}
                value={data[campo.key]}
                onChange={handleChange}
                opciones={opciones}
                modoEdicion={modoEdicion}
                campoNoEditable={campoNoEditable}
              />
            ))}
          </div>
        </div>
      )}
      {!porGrupos && bloqueSecondary.length > 0 && (
        <div className={`${isDouble ? "doble-form-left" : ""}`}>
          <label>
            <strong className="form-info-title">Otros datos</strong>
          </label>
          <div className="form-info-box">
            {bloqueSecondary.map((campo) => (
              <InputForm
                key={campo.key}
                campo={campo}
                value={data[campo.key]}
                onChange={handleChange}
                opciones={opciones}
                modoEdicion={modoEdicion}
                campoNoEditable={campoNoEditable}
              />
            ))}
          </div>
        </div>
      )}
      {bloqueComplete.length > 0 && (
        <div className="doble-form-right">
          <label>
            <strong className="form-info-title">Registrar</strong>
          </label>
          <div className="form-info-box">
            <FormList
              articulos={listado}
              value={data.ingresos || []}
              onChange={(nuevoListado) =>
                handleChange("ingresos", nuevoListado)
              }
              mostrarTipoMovimiento={
                bloqueComplete[0]?.mostrarTipoMovimiento ?? true
              }
              {...listaProps}
            />
          </div>
        </div>
      )}
      {bloqueChecks.length > 0 && (
        <div className="doble-form-right">
          <label>
            <strong className="form-info-title">Chequeos</strong>
          </label>
          <div className="checkbox-list">
            {bloqueChecks[0].items.map((item) => {
              const activo = data.chequeos?.[item.key] ?? false;
              return (
                <button
                  key={item.key}
                  type="button"
                  className={`boolean-btn ${activo ? "activo" : "inactivo"}`}
                  onClick={() =>
                    setData((prev) => ({
                      ...prev,
                      chequeos: {
                        ...prev.chequeos,
                        [item.key]: !activo,
                      },
                    }))
                  }
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default FormContent;
